import { Col, Row, RowProps, UiIcon, UiImage, UiText } from "~/components/elements";
import images from "~/assets/img";
import React from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { HeadshotStyleApiItem, PhotoshootType } from "~/types/models/dashboard";

interface HeadshotStyleListItemProps extends Omit<RowProps, "onSelect"> {
  headshotStyle: HeadshotStyleApiItem;
  filterable: boolean;
  closeable?: boolean;
  onSelect?: (hss: HeadshotStyleApiItem) => void;
  onClickClose?: (hss: HeadshotStyleApiItem) => void;
  photoshootType?: PhotoshootType;
}

export function HeadshotStyleListItem({
  headshotStyle,
  filterable,
  onSelect,
  onClickClose,
  closeable = true,
  photoshootType,
  ...rest
}: HeadshotStyleListItemProps) {
  const onClick = (e: React.FormEvent) => {
    if (!filterable) {
      e?.preventDefault();
      return;
    }
    onSelect?.(headshotStyle);
  };

  const renderPreviewImage = () => <Row ml={2} />;
  // if (photoshootType === "two_person") {
  //   return <Row ml={2} />;
  // }
  //
  // if (headshotStyle.woman_preview_photo_url && headshotStyle.man_preview_photo_url) {
  //   return (
  //     <Row mr={2} w="4rem" minW="4rem">
  //       <UiImage
  //         src={headshotStyle.man_preview_photo_url}
  //         borderLeftRadius="0.5rem"
  //         h="2.625rem"
  //         objectFit="cover"
  //         objectPosition="top"
  //       />
  //       <UiImage
  //         src={headshotStyle.woman_preview_photo_url}
  //         borderRightRadius="0.5rem"
  //         h="2.625rem"
  //         objectFit="cover"
  //         objectPosition="top"
  //       />
  //     </Row>
  //   );
  // }
  // return (
  //   <Row mr={2} w="4rem" minW="4rem">
  //     <UiImage src={images.snapglogo} borderRadius="0.5rem" h="2.625rem" objectFit="cover" />
  //   </Row>
  // );
  return (
    <Row
      rounded="xl"
      bg={headshotStyle.isSelected ? "lightblue" : "white"}
      borderWidth="1px"
      borderStyle={!closeable ? "dashed" : "solid"}
      borderColor={headshotStyle.isSelected || !closeable ? "blue" : "transparent"}
      p={2}
      w="full"
      minW="14.9rem"
      _hover={{ cursor: filterable ? "pointer" : "default" }}
      onClick={onClick}
      {...rest}
    >
      {renderPreviewImage()}
      <Col flexGrow={1} justifyContent="space-between">
        <UiText vr="title2" noOfLines={1}>
          {headshotStyle.name}
        </UiText>
        <UiText vr="body2" color="neutral.gray400" noOfLines={1}>
          {photoshootType === "two_person" ? "Outfits will be auto generated" : headshotStyle.outfit_name}
        </UiText>
      </Col>
      {closeable && onClickClose && (
        <Col justifyContent="center" onClick={() => onClickClose?.(headshotStyle)} _hover={{ cursor: "pointer" }}>
          <UiIcon as={AiOutlineCloseCircle} mx={0} boxSize={6} color="neutral.gray300" />
        </Col>
      )}
    </Row>
  );
}
